module.exports = __webpack_public_path__ + "img/bg1.75e47de1.jpg";